import { FlyerDetailAddPageState } from "./flyer-detail-add-page-state.interface";

export function createFlyerDetailAddPageState(): FlyerDetailAddPageState {
  return {
    templates: null,
    selectedTemplateId: -1,
    isLoading: false,
  };
}
